import React, { useState } from 'react'
import { MDBIcon } from "mdbreact";

import Question from '../Question'

import styles from "./index.module.scss";

const Button = ({ func, icon, code }) => (
  <div className={styles['button']} data-type={icon} onClick={() => func(code)}>
    <MDBIcon icon={icon} />
  </div>
)

const QuestionTable = ({
  questions,
  addQuestion,
  removeQuestion,
  editQuestion,
  search
}) => {
  const [input, setInput] = useState("")

  return (
    <div className={styles.table}>
      { !!search && (
        <div className={styles.input}>
          <input
            className={`form-control`}
            type="text"
            placeholder="Termo livre"
            value={input}
            onChange={e => setInput(e.currentTarget.value)}
            onKeyUp={e => { if (e.keyCode == 13) search(input) }}
          />
          <Button
            func={() => search(input)}
            icon="search"
          />
        </div>
      )}
      <div className={styles.questions}>
        <div>
          <div>Questão</div>
          <div>Comentário</div>
          <div>Opções</div>
        </div>
        <div>
          { questions.map(question => (
            <div key={question.codigo}>
              <Question question={question} />
              <div>
                { !!addQuestion && (
                  <Button
                    func={addQuestion}
                    icon="plus"
                    code={question}
                  />
                )}
                { !!editQuestion && (
                  <Button
                    func={editQuestion}
                    icon="pencil-alt"
                    code={question.codigo}
                  />
                )}
                { !!removeQuestion && (
                  <Button
                    func={removeQuestion}
                    icon="times"
                    code={question.codigo}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default QuestionTable
